export const FAB_TRIGGER_SIZE_DEFAULT = 64;

// "?" glyph size relative to the box: 30px (text-3xl) / 64px default box. Keeps the
// default glyph proportional as the trigger shrinks; em-based content (text, MUI
// SvgIcon) scales with it too.
export const GLYPH_RATIO = 0.47;

export const DEFAULT_ARIA_LABEL = "Open help menu";
export const DEFAULT_TOOLTIP = "Guided tours & help";
export const DEFAULT_PH_ACTION = "open_tour_menu";
